import { create } from 'zustand';
import { getWebSocketUrl } from '../config';
import { Ligue } from '@prisma-remote/client';

interface LigueState {
  ligues: Ligue[];
  fetchLigues: () => Promise<void>;
}

const serverUrl = getWebSocketUrl();

export const useLigueStore = create<LigueState>((set) => ({
  ligues: [],
  fetchLigues: async () => {
    const response = await fetch(`${serverUrl}/ligues`)
      if(response.ok) {
      const ligues = await response.json();
    set({ ligues })
    } else {
      set({ ligues: []})
    }
  }
}));
